import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = t((e, l) => /* @__PURE__ */ o.jsx(
  r,
  {
    ref: l,
    ...e,
    image: (a) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM14.711 20h-1.834v-8.402h1.834v3.685l2.947-3.685h2.215l-2.853 3.398L19.979 20h-2.133l-2.033-3.568-1.102 1.312z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "KetoconazoleIcon";
export {
  i as KetoconazoleIcon,
  i as default
};
//# sourceMappingURL=index.js.map
